import style from './style.module.css';
import { PageHeaderWithSpace } from '../../components/common/PageHeaderWithSpace/PageHeaderWithSpace';
import { Tabs, TabPane } from 'fave-ui';
import FaveFundedCashback from './FaveCashbackView';
import FLPFundedCashback from './FLPCashbackView';
import ECardGiveawayView from './ECardGiveawayView';
import { useLocation, useNavigate } from 'react-router';

export const cashbackCampaignTabs = [
  {
    key: 'flp-funded',
    label: `FLP Funded Cashback`,
    children: <FLPFundedCashback />,
    funder_type: 'Flp::Client',
  },
  {
    key: 'fave-funded',
    label: `Fave Funded Cashback`,
    children: <FaveFundedCashback />,
    funder_type: 'Fave',
  },
  {
    key: 'ecard-giveaway',
    label: `BKE eCard Giveaway`,
    children: <ECardGiveawayView />,
    funder_type: 'BKE::ECard',
  },
];

const CashbackCampaignsView = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const activeTab =
    cashbackCampaignTabs.filter(tab => tab.key === searchParams.get('tab'))[0]
      ?.key || cashbackCampaignTabs[0].key;

  function handleTabChange(key: string) {
    searchParams.set('tab', key);
    navigate(`${window.location.pathname}?${searchParams}`, {
      replace: true,
    });
  }
  return (
    <>
      <PageHeaderWithSpace title={'Cashback campaign'} subTitle={''} />
      <Tabs
        className={style.tabs}
        activeKey={activeTab}
        onTabClick={handleTabChange}
      >
        {cashbackCampaignTabs.map(item => (
          <TabPane {...item} tab={<span>{item.label}</span>} key={item.key} />
        ))}
      </Tabs>
    </>
  );
};

export default CashbackCampaignsView;
